import { render } from "./CadastroOrcamentoPlanilha.vue?vue&type=template&id=3791c245"
import script from "./CadastroOrcamentoPlanilha.vue?vue&type=script&lang=js"
export * from "./CadastroOrcamentoPlanilha.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__